import React from 'react';
import { Image, View } from 'react-native-web';
import {
  img_bank_back,
  img_bank_door,
  img_bank_main,
  img_bank_main_bg,
  img_bank_shield_color,
  img_bank_shield_mask,
  img_bank_stars,
  img_bank_stars_bg,
} from '../../../../utils/ImagesManagementUtils';

//= ========================================================================

const TempleScreenShot = ({
  globJSON,
}) => {
  const { colors } = globJSON.configurations.theme;
  const myStyles = {
    bankImage: {
      width: 182,
      height: 202,
      alignSelf: 'center',
      position: 'absolute',
    },
    bankStars: {
      width: 182,
      height: 202,
      alignSelf: 'center',
      position: 'absolute',
    },
  };
  return (
    <View>
      <Image
        fadeDuration={0}
        style={[
          myStyles.bankStars,
          { tintColor: colors.pressed_cta_color },
        ]}
        source={img_bank_stars_bg}
      />
      <Image
        fadeDuration={0}
        style={[
          myStyles.bankStars,
          { tintColor: colors.cta_font_color },
        ]}
        source={img_bank_stars}
      />

      <Image
        fadeDuration={0}
        style={[
          myStyles.bankImage,
          { tintColor: colors.pressed_cta_color },
        ]}
        source={img_bank_back}
      />

      <Image
        fadeDuration={0}
        style={[
          myStyles.bankImage,
          { tintColor: colors.primary_cta_color },
        ]}
        source={img_bank_main_bg}
      />
      <Image
        fadeDuration={0}
        style={myStyles.bankImage}
        source={img_bank_door}
      />
      <Image
        fadeDuration={0}
        style={myStyles.bankImage}
        source={img_bank_main}
      />

      <Image
        fadeDuration={0}
        style={[
          myStyles.bankImage,
          { tintColor: colors.positive_color },
        ]}
        source={img_bank_shield_color}
      />
      <Image
        fadeDuration={0}
        style={myStyles.bankImage}
        source={img_bank_shield_mask}
      />
    </View>
  );
};
export default TempleScreenShot;
